<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="5">
                            <el-form-item label="功能編號">
                                <el-input v-model="searchForm.FUNC_ID"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="功能名稱">
                                <el-input v-model="searchForm.CHI_DESC"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onAddClick()" v-show="store.getters.check_auth('ADD')">新增</el-button>
                    <el-button type="primary" round plain v-show="store.getters.check_auth('PRINT')">列印</el-button>
                </el-row>

                <div ref="table" style="margin-top:10px;"></div>
            </div>

            <!--功能資料-->
            <el-dialog :title="dialogTitle" width="45%" v-model="dialogFormVisible"
                       @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
                <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="功能編號" prop="FUNC_ID">
                                <el-input v-model="form.FUNC_ID" :disabled="IDdisabled" maxlength="20"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="功能類別" prop="FUNC_TYPE">
                                <el-input v-model="form.FUNC_TYPE" maxlength="10"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="功能名稱(中文)" prop="CHI_DESC">
                                <el-input v-model="form.CHI_DESC" maxlength="50"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="功能名稱(英文)" prop="ENG_DESC">
                                <el-input v-model="form.ENG_DESC" maxlength="50"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="標籤名稱(中文)" prop="TAB_CHI_TITLE">
                                <el-input v-model="form.TAB_CHI_TITLE" maxlength="10"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="標籤名稱(英文)" prop="TAB_ENG_TITLE">
                                <el-input v-model="form.TAB_ENG_TITLE" maxlength="30"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="上層編號" prop="PARENT_ID">
                                <el-input v-model="form.PARENT_ID" maxlength="20"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="頁面URL" prop="URL_ADDR">
                                <el-input v-model="form.URL_ADDR" maxlength="200"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="備註" prop="REMARKS" label-width="auto">
                                <el-input v-model="form.REMARKS" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-row>
                                <el-col :span="6" style="display: flex; align-items: center;">
                                    <span>可否執行</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-switch v-model="form.SET_RUN"
                                               active-color="#13ce66" inactive-color="#ff4949"
                                               active-value="true" inactive-value="false">
                                    </el-switch>
                                </el-col>
                                <el-col :span="6" style="display: flex; align-items: center;">
                                    <span>可否修改</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-switch v-model="form.SET_MODIFY"
                                               active-color="#13ce66" inactive-color="#ff4949"
                                               active-value="true" inactive-value="false">
                                    </el-switch>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="6" style="display: flex; align-items: center;">
                                    <span>可否查詢</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-switch v-model="form.SET_SEARCH"
                                               active-color="#13ce66" inactive-color="#ff4949"
                                               active-value="true" inactive-value="false">
                                    </el-switch>
                                </el-col>
                                <el-col :span="6" style="display: flex; align-items: center;">
                                    <span>可否刪除</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-switch v-model="form.SET_DEL"
                                               active-color="#13ce66" inactive-color="#ff4949"
                                               active-value="true" inactive-value="false">
                                    </el-switch>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="6" style="display: flex; align-items: center;">
                                    <span>可否新增</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-switch v-model="form.SET_ADD"
                                               active-color="#13ce66" inactive-color="#ff4949"
                                               active-value="true" inactive-value="false">
                                    </el-switch>
                                </el-col>
                                <el-col :span="6" style="display: flex; align-items: center;">
                                    <span>可否列印</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-switch v-model="form.SET_PRINT"
                                               active-color="#13ce66" inactive-color="#ff4949"
                                               active-value="true" inactive-value="false">
                                    </el-switch>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
                <template #footer class="dialog-footer">
                    <el-button type="primary" @click="dialogFormVisible = false">Close</el-button>
                    <el-button type="primary" @click="onSubmit">Save</el-button>
                </template>
            </el-dialog>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus';
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogTitle = ref('');//dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const addOrEdit = ref('');
    const formRef = ref(null);
    const formData = ref(null);

    const searchForm = reactive({
        FUNC_ID: '',
        CHI_DESC: ''
    });

    const form = ref({
        FUNC_ID: '',
        FUNC_TYPE: 'WEB',
        CHI_DESC: '',
        ENG_DESC: '',
        PARENT_ID: '',
        TAB_CHI_TITLE: '',
        TAB_ENG_TITLE: '',
        URL_ADDR: '',
        REMARKS: '',
        SET_RUN: 'false',
        SET_SEARCH: 'false',
        SET_PRINT: 'false',
        SET_MODIFY: 'false',
        SET_DEL: 'false',
        SET_PRINT: 'false'
    });

    const rules = reactive({
        FUNC_ID: [{ required: true, message: '請輸入功能編號', trigger: 'blur' }],
        FUNC_TYPE: [{ required: true, message: '請輸入功能類別', trigger: 'blur' }],
        CHI_DESC: [{ required: true, message: '請輸入功能名稱(中文)', trigger: 'blur' }],
        ENG_DESC: [{ required: true, message: '請輸入功能名稱(英文)', trigger: 'blur' }],
        TAB_CHI_TITLE: [{ required: true, message: '請輸入標籤名稱(中文)', trigger: 'blur' }],
        TAB_ENG_TITLE: [{ required: true, message: '請輸入標籤名稱(英文)', trigger: 'blur' }],
        PARENT_ID: [{ required: true, message: '請輸入上層編號', trigger: 'blur' }]
    });

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = () => {
        $api.GET('/api/SysFunc/GetTableData', searchForm
        ).then((response) => {
            tabulator.value.setData(response);
        });
    };

    const onSearch = () => {
        onLoadTable();
    };

    const onAddClick = () => {
        IDdisabled.value = false;
        addOrEdit.value = 'add';
        dialogFormVisible.value = true;
        dialogTitle.value = '新增系統功能';

        nextTick(() => {
            formRef.value.resetFields();
        })
    };

    const onDialogOpen = () => {
        if (addOrEdit.value == 'edit') {
            nextTick(() => {
                form.value = formData.value;
            })
        }
    }

    const onEditClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));

        IDdisabled.value = true;
        addOrEdit.value = 'edit';
        dialogFormVisible.value = true;
        dialogTitle.value = '編輯系統功能';
    };

    const onSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                console.log(form.value);
                if (addOrEdit.value == 'add') {
                    $api.POST('/api/SysFunc/Add', form.value
                    ).then((res) => {
                        if (res == -2) {
                            ElMessageBox.alert('重複的功能代碼，無法新增!', '提示', {
                                confirmButtonText: '確定'
                            });
                        } else {
                            ElMessageBox.alert('新增成功!', '提示', {
                                confirmButtonText: '確定',
                                callback: action => {
                                    dialogFormVisible.value = false;
                                    onLoadTable();
                                }
                            });
                        }
                    })
                } else {
                    $api.POST('/api/SysFunc/Edit', form.value
                    ).then((res) => {
                        ElMessageBox.alert('編輯成功!', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                dialogFormVisible.value = false;
                                onLoadTable();
                            }
                        });
                    })
                }
            }
        });
    };

    const onDeleteClick = (e, cell) => {
        console.log(cell);
        ElMessageBox.confirm('確定要刪除?', '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            $api.POST('/api/SysFunc/Delete',
                cell.getData(),
            ).then((res) => {
                ElMessageBox.alert('刪除成功!', '提示', {
                    confirmButtonText: '確定',
                    callback: action => {
                        onLoadTable();
                    }
                });
            }).catch((error) => {
                ElMessageBox.alert('刪除失敗!', '提示', {
                    confirmButtonText: '確定'
                });
            });
        });
    };

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }

    const deleteIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64h256zm64 0h192v-64H416v64zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32H192zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32zm192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32z"></path></svg></i>';
    }

    const ckParams = (cell) => {
        if (cell.getValue() == null || cell.getValue() == 'N') {
            cell.setValue("false");
        } else if (cell.getValue() == 'Y') {
            cell.setValue("true");
        }
        return {
            tickElement: '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M77.248 415.04a64 64 0 0 1 90.496 0l226.304 226.304L846.528 188.8a64 64 0 1 1 90.56 90.496l-543.04 543.04-316.8-316.8a64 64 0 0 1 0-90.496z"></path></svg></i>',
            crossElement: "",
        };
    }

    onMounted(() => {
        onLoadTable();

        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "100%", //do not let table get bigger than the height of its parent element
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            dataTree: true,
            dataTreeStartExpanded: true,
            initialSort: [             //set the initial sort order of the data
                { column: "FUNC_ID", dir: "asc" },
            ],
            columns: [                 //define the table columns
                { title: "功能編號", field: "FUNC_ID", headerHozAlign: "center", hozAlign: "center" },
                { title: "功能名稱", field: "CHI_DESC", headerHozAlign: "center", hozAlign: "center" },
                { title: "執行", field: "SET_RUN", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: "tickCross", formatterParams: ckParams },
                { title: "查詢", field: "SET_SEARCH", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: "tickCross", formatterParams: ckParams },
                { title: "新增", field: "SET_ADD", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: "tickCross", formatterParams: ckParams },
                { title: "修改", field: "SET_MODIFY", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: "tickCross", formatterParams: ckParams },
                { title: "刪除", field: "SET_DEL", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: "tickCross", formatterParams: ckParams },
                { title: "列印", field: "SET_PRINT", headerHozAlign: "center", hozAlign: "center", headerSort: false, formatter: "tickCross", formatterParams: ckParams },
                { title: "編輯", field: "edit", formatter: editIcon, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onEditClick },
                { title: "刪除", field: "delete", formatter: deleteIcon, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onDeleteClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                tabulator.value.hideColumn('edit');
            }
            if (!store.getters.check_auth('DEL')) {
                tabulator.value.hideColumn('delete');
            }
        });
    })
</script>
<style></style>